// tslint:disable
export enum OrderingSystemCode {
    /**
     * @description Torro
     */
    Torro = 1,
    /**
     * @description Campaign
     */
    Campaign = 2,
}
(OrderingSystemCode as any)['TORRO'] = 1;
(OrderingSystemCode as any)['CAMPAIGN'] = 2;
